
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vascular-surgery",
      function () {
        return require("private-next-pages/vascular-surgery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vascular-surgery"])
      });
    }
  